<script setup>
import { toRefs } from "vue";
const props = defineProps({
  vtuber_image: String,
});

const { vtuber_image } = toRefs(props);
</script>

<template>
  <div class="banner-container">
    <!-- <v-img :src="card.vtuber_image" contain /> -->
    <img :src="vtuber_image" alt="VTuber banner image" />
  </div>
</template>

<style scoped>
.banner-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

img {
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
  object-fit: contain;
}
</style>
